import {
  Badge,
  Box,
  CloseButton,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { NcmAnalysisItem } from "../../../../models/Process";

const verdictColor = (verdict?: string) => {
  if (verdict === "Correto") return "green";
  if (verdict === "Incorreto") return "red";
  return "yellow";
};

const verdictLabel = (verdict?: string) => {
  if (verdict === "Correto") return "✓ Correto";
  if (verdict === "Incorreto") return "✗ Incorreto";
  return "? Inconclusivo";
};

const NcmAnalysisModal = ({
  isOpen,
  onClose,
  analyses,
}: {
  isOpen: boolean;
  onClose: () => void;
  analyses: NcmAnalysisItem[];
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="3xl"
      scrollBehavior="inside"
    >
      <ModalOverlay backdropFilter="blur(2px)" bg="blackAlpha.600" />
      <ModalContent borderRadius="16px" boxShadow="0 12px 32px rgba(16,24,40,0.18)">
        <ModalHeader>
          <Flex justifyContent="space-between" alignItems="center">
            <Heading size="md" fontWeight="semibold">
              Análise de NCM — Classificador Aduaneiro
            </Heading>
            <CloseButton onClick={onClose} />
          </Flex>
        </ModalHeader>

        <ModalBody pb="32px">
          {analyses.length === 0 ? (
            <Text color="gray.500">Nenhuma análise disponível.</Text>
          ) : (
            <Flex flexDir="column" gap="24px">
              {analyses.map((item, idx) => (
                <Box
                  key={idx}
                  p="20px"
                  borderRadius="8px"
                  borderWidth="1px"
                  borderColor={
                    item.verdict === "Correto"
                      ? "green.200"
                      : item.verdict === "Incorreto"
                      ? "red.200"
                      : "yellow.200"
                  }
                  backgroundColor={
                    item.verdict === "Correto"
                      ? "green.50"
                      : item.verdict === "Incorreto"
                      ? "red.50"
                      : "yellow.50"
                  }
                >
                  {/* Header row */}
                  <Flex
                    justifyContent="space-between"
                    alignItems="flex-start"
                    mb="12px"
                    flexWrap="wrap"
                    gap="8px"
                  >
                    <Box>
                      <Text fontWeight="bold" fontSize="sm" color="gray.500" mb="2px">
                        Produto
                      </Text>
                      <Text fontWeight="semibold">{item.product ?? "—"}</Text>
                    </Box>

                    <Flex gap="12px" alignItems="center" flexWrap="wrap">
                      <Box textAlign="right">
                        <Text fontWeight="bold" fontSize="sm" color="gray.500" mb="2px">
                          NCM analisado
                        </Text>
                        <Text fontFamily="mono" fontWeight="semibold">
                          {item.ncm ?? "não informado"}
                        </Text>
                      </Box>

                      <Badge
                        colorScheme={verdictColor(item.verdict)}
                        p="8px"
                        fontSize="sm"
                        borderRadius="4px"
                      >
                        {verdictLabel(item.verdict)}
                      </Badge>
                    </Flex>
                  </Flex>

                  {/* Analysis text */}
                  <Text fontSize="sm" color="gray.700" lineHeight="1.6">
                    {item.analysis}
                  </Text>

                  {/* Suggested NCM when incorrect */}
                  {item.verdict === "Incorreto" && item.suggestedNcm && (
                    <Flex
                      mt="12px"
                      p="10px"
                      backgroundColor="red.100"
                      borderRadius="4px"
                      alignItems="center"
                      gap="8px"
                    >
                      <Text fontWeight="bold" fontSize="sm">
                        NCM sugerido:
                      </Text>
                      <Text fontFamily="mono" fontWeight="semibold" fontSize="sm">
                        {item.suggestedNcm}
                      </Text>
                    </Flex>
                  )}
                </Box>
              ))}
            </Flex>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default NcmAnalysisModal;
